// extracted by mini-css-extract-plugin
module.exports = {"submitButton__root":"submitButton__root-2P05r","codeForm__resendLabel":"codeForm__resendLabel-2cWiI"};